import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useSetState } from 'ahooks'
import {
  SActionBtn,
  SBack,
  SDrawerOrModal,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { Button, message, Upload } from 'antd'
import {
  addDiscountRatioManage,
  deletedBatchByIdsDiscountRatioManage,
  deleteDiscountRatioManage,
  discountRatioManagePage,
  getBrandPage,
  getGoodsCommonPage,
  getProductCommonPage,
  importFileDeleteDiscount,
  updateDiscountRatioManage,
} from '@/services/product.ts'
import { config } from './config.tsx'
import { AddOrEditStandard } from './addOrEdit.tsx'
import { useParams, useSearchParams } from 'react-router-dom'
import { apiData2Table } from '@/utils/data.ts'
import { DownloadOutlined, UploadOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import { httpOrgList, getRoleList } from '@/services/homeService.ts'
import DebounceSelect from '../components/DebounceSearchSelect/index.tsx'
import {
  BaWBatchAddConfigs,
  BaWPage,
  BaWPageDelete,
  BaWUpdateById,
  getGoodsPage,
} from '@/services/goods.ts'

export const BlackAndWhite = forwardRef((props, ref) => {
  const [searchParams] = useSearchParams({})
  const listRef = useRef()
  const editRef = useRef()

  const [state, setState] = useSetState({
    visible: false,
    record: {},
    btnLoading: false,
    exportLoading: false,
    importLoading: false,
    loading: false,
    companyList: [],
  })

  useImperativeHandle(ref, () => {
    return { getData: () => listRef.current?.getDataSource() }
  })
  const fetchList = ({ current, pageSize, query }) => {
    query.showName = true
    return new Promise((resolve, reject) => {
      BaWPage({ ...query, current, pageSize })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()

  const onEdit = (record = {}) => {
    setState({ visible: true, record })
  }

  const onDel = record => {
    SMessage.confirm({
      onOk: () => {
        return BaWPageDelete({ ids: [record.id] }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }
  const getOptions = () => {
    return new Promise(async (resolve, reject) => {
      const companyList: any = await httpOrgList()
      resolve({
        companyList: [...companyList],
      })
    })
  }
  const onBatchDelete = ({ selectedRowKeys }) => {
    SMessage.confirm({
      content: `是否确认删除所选数据`,
      onOk: () => {
        return BaWPageDelete({ ids: selectedRowKeys }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: { onAdd, onBatchDelete },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {[
              <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>,
              <SActionBtn danger onClick={() => onDel(record)}>
                删除
              </SActionBtn>,
            ]}
          </STableActions>
        )
      },
      brandRender({ name, form }) {
        return (
          <DebounceSelect
            allowClear
            label={'品牌'}
            enabled={null}
            fetchOptions={getBrandPage}
            onChange={v => form.setFieldsValue({ [name]: v })}
          />
        )
      },
      goodsRender({ name, form }) {
        return (
          <DebounceSelect
            allowClear
            label={'商品'}
            isCommon={false}
            fixedParams={{ prodType: 'PRODUCT_PACKAGE', enabled: true }}
            fetchOptions={getGoodsPage}
            fieldNames={{ label: 'goodsName', value: 'id' }}
            onChange={v => form.setFieldsValue({ [name]: v })}
            nameKey={'showNameKey'}
          />
        )
      },
    },
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const onSubmit = () => {
    editRef.current?.onFinish()
  }

  const onSubmitOk = values => {
    const apiUrl = values.id ? BaWUpdateById : BaWBatchAddConfigs
    apiUrl(values)
      .then((res: any) => {
        message.success(res.message || '操作成功')
        listRef.current?.reload()
        onCancel()
      })
      .finally(() => {
        setState({ btnLoading: false })
      })
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} ref={listRef} config={{ ...config }} {...extensions} />
      <SDrawerOrModal
        title={state.record.id ? '编辑' : '新增' + '配置'}
        width={500}
        open={state.visible}
        onOk={onSubmit}
        loading={state.btnLoading}
        onCancel={onCancel}
      >
        {state.visible && (
          <AddOrEditStandard
            record={state.record}
            ref={editRef}
            fn={onSubmitOk}
            setLoading={(btnLoading: boolean) => setState({ btnLoading })}
          />
        )}
      </SDrawerOrModal>
    </>
  )
})
